module.exports = __webpack_public_path__ + "05f6e8a9bf0a3bc9ba40e7d161f2d5b9.jpg";